export default function newsScripts() {
    
    const newsBlock = document.querySelector('section.news')
    const filter = document.querySelector('.news__filter')
    
    if (!newsBlock || !filter) {
        return
    }
    
    const newsGrid = newsBlock.querySelector('.news__grid')
    const select = filter.querySelector('.news__filter-select'),
      list = filter.querySelector('.news__filter-list'),
      listItems = [].slice.apply(list.querySelectorAll('li'))
    
    select.addEventListener('click', () => {
        filter.classList.contains('is--open') ? filter.classList.remove('is--open')
                                              : filter.classList.add('is--open')
    })
    
    listItems.forEach(li => {
        li.addEventListener('click', () => {
            
            listItems.forEach(item => {
                item.classList.remove('is--active')
            })
            
            li.classList.add('is--active')
            filter.classList.remove('is--open')
            filter.querySelector('.-current').textContent = li.textContent
            
            filterNews(li.dataset.id)
        })
    })
    
    function filterNews(id) {
        filter.classList.add('filtering')
        newsGrid.classList.add('loading')
        
        $.ajax({
            method: 'POST',
            url: window.MS_Ajax.ajaxurl,
            data: {
                action: 'filter-news',
                id: id,
            },
        }).done(data => {
            filter.classList.remove('filtering')
            newsGrid.classList.remove('loading')
            newsGrid.innerHTML = data
            
        }).fail(err => {
            console.log(err)
        })
    }
    
}